import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    this.modalTarget.classList.add("guest-modal--open")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.remove("guest-modal--open")
    document.body.style.overflow = ""
  }

  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
